<template>
  <Head title="Hilfe" />
  <div class="flex justify-between flex-wrap">
    <h1 class="mb-8 text-3xl font-bold flex items-center text-orfBlue-100">
      <HeroIcon name="question-mark-circle" class="mr-2 h-10 w-10 fill-orfBlue-100" />
      <div class="mt-1">Hilfe & Informationen</div>
    </h1>
  </div>
  <div class="my-4">
    <h2 class="text-2xl font-bold">Allgemein</h2>
    <p class="mt-2 leading-normal">
      Dieses Tool bietet eine Übersicht über die Office-Auslastung der jeweiligen Abteilungen. Außerdem gibt es einen Urlaubskalender.<br />
    </p>
  </div>
  <div class="my-4">
    <h2 class="text-2xl font-bold">Kontakt</h2>
    <p class="mt-2 leading-normal">
      Bei <b>Fragen/Problemen/Bugs</b> zögere bitte nicht uns per E-Mail an <a class="font-bold" href="mailto:adtechnology@orf.at">adtechnology@orf.at</a> zu kontaktieren.
    </p>
  </div>
  <hr />
  <div class="my-4">
    <h2 class="text-2xl font-bold">Kalender-Anleitung</h2>
    <div class="my-4">
      <div class="font-bold">Termin erstellen</div>
      <p class="mt-2 leading-normal md:pl-4">
        <b class="mr-3">1.</b>Um einen Termin zu erstellen klicke in dem jeweiligen Kalenderfenster des gewünschten Tages auf die freie Fläche. <br />
        <b class="mr-3">2.</b>Danach wähle in dem PopUp die Art des Termins (Office-Tag = "Büro" ODER "Urlaub") aus.<br />
        <b class="mr-3">3.</b>Darunter gib noch das richtige Datum ein (Bei Urlaub: Start- & End-Datum).<br /><br />
        Alternativ kannst du über den Menüpunkt "Meine Termine" und dem Button Termin erstellen auch einen Termin erstellen
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Kalender-Ansichten & Optionen:</div>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Office- & Urlaubs-Kalender:</b> <br />
        Klick auf den jeweiligen Button rechts über dem Kalender um zwischen dem Office- & Urlaubs-Kalender zu wechseln. <i>Default: "Office"</i>
      </p>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Wochen- & Monats-Ansicht</b> <br />
        In der Kalender-Kopfzeile rechts neben dem Datum gibt es die Möglichkeit zwichen Wochen-(7 Tage) & Monats-Ansicht zu wechseln. <i>Default: "Woche"</i>
      </p>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Wochenenden anzeigen</b> <br />
        Klick auf den Toogle-Button "Wochenende anzeigen" rechts über dem Kalender um die Wochenenden anzuzeigen bzw. auszublenden. <i>Default: "Ausgeblendet"</i>
      </p>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Mein Kalender</b> <br />
        Klick auf den Button "Mein Kalender" links über dem Kalender um deinen persönlichen Kalender zu sehen.
      </p>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Suche</b> <br />
        Suche im Suchfeld nach einem Mitarbeiter um seinen persönlichen Kalender (Office & Urlaub) zu sehen bzw. seinen heutigen Status ("Heute im ...").
      </p>
      <p class="mt-2 leading-normal md:pl-4 my-2">
        <b class="mr-3">Teams</b> <br />
        Über dem Kalender gibt es die Möglichkeit zwischen den Kalendern der Teams der jeweiligen Abteilung (zB.: Sales) zu wechseln.  <i>Default: "Alle" (Alle Termine der jeweiligen Teams der Abteilung)</i>
      </p>
    </div>
  </div>
  <hr />
  <div class="my-4">
    <h2 class="text-2xl font-bold">Seiten</h2>
    <div class="my-4">
      <div class="font-bold">Dashboard/Kalender</div>
      <p class="mt-2 leading-normal md:pl-4">
        Unter "Dashboard" findest du den Kalender mit all seinen Funktionen.
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Meine Termine</div>
      <p class="mt-2 leading-normal md:pl-4">
        Unter "Meine Termine" findest du eine Übersicht über alle deine eingetragenen Termine. Du kannst nach Art (Büro, Urlaub) filtern.
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Mitarbeiter/Innen</div>
      <p class="mt-2 leading-normal md:pl-4">
        Unter "Mitarbeiter/Innen" findest du eine Übersicht über alle Mitarbeiter/Innen wo du mit Klick auf den "Kalender" Button rechts in den Zeilen, deren persönlichen Kalender einsehen kannst. Außderem kannst du nach Namen und Email suchen bzw. nach Abteilung und Team filtern.
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Abteilungen</div>
      <p class="mt-2 leading-normal md:pl-4">
        Unter "Abteilungen" findest du eine Übersicht über alle Abteilungen und deren Teams sowie welcher Admin für die jeweilige Abteilung zuständig ist. Bei Klick auf den "Kalender" Button rechts in den Zeilen kannst du den jeweiligen Kalender der ausgewählten Abteilung einsehen.
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Feedback</div>
      <p class="mt-2 leading-normal md:pl-4">
        Über den Button "Feedback" rechts oben im Menü kannst du gerne ein Feedback zu dem Tool abgeben. Alternativ kannst du auch gerne per Email an unsere Kontakt-Adresse schreiben.
      </p>
    </div>
  </div>
  <hr />
  <div class="my-4" v-if="is_admin">
    <h2 class="text-2xl font-bold">Admin-Anleitung</h2>
    <div class="my-4">
      <div class="font-bold">Mitarbeiter/In erstellen</div>
      <p class="mt-2 leading-normal md:pl-4">
        <b class="mr-3">1.</b>Gehe im Menü auf "Abteilungen" und klicke dann bei deiner Abteilung auf "Bearbeiten". <br />
        <b class="mr-3">2.</b>Klicke danach rechts auf den Button "Mitarbeiter/in erstellen".<br />
        <b class="mr-3">3.</b>Fülle die Felder "Vorname", "Nachname" und "Email" aus.<br />
        <b class="mr-3">4.</b>Wähle bei "Team" entweder "Kein Team" oder das gewünschte Team aus und klicke auf "Mitarbeiter/In erstellen"<br />
        <b class="mr-3">5.</b>Schicke, dem/der Mitarbeiter/In den Copy-Paste-Text mit dem angezeigten Bestätigungs-Link <b>(Link ist maximal 2 Tage gültig)</b>.<br />
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Mitarbeiter bearbeiten</div>
      <p class="mt-2 leading-normal md:pl-4">
        <b class="mr-3">1.</b>Gehe im Menü auf "Mitarbeiter/Innen". <br />
        <b class="mr-3">2.</b>Suche nach dem gewünschten Mitarbeiter und klicke rechts in der Zeile auf "Bearbeiten".<br />
        <b class="mr-3">3.</b>Dort kannst du nun den Mitarbeiter bearbeiten bzw. ihn in ein anderes Team wechseln"<br /><br />
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Passwort zurücksetzen</div>
      <p class="mt-2 leading-normal md:pl-4">
        <b class="mr-3">1.</b>Gehe im Menü auf "Mitarbeiter/Innen". <br />
        <b class="mr-3">2.</b>Suche nach dem gewünschten Mitarbeiter und klicke rechts in der Zeile auf "Bearbeiten".<br />
        <b class="mr-3">3.</b>Klicke ganz unten in der Mitte auf den Button "Passwort zurücksetzen"<br />
        <b class="mr-3">4.</b>Schicke, dem/der Mitarbeiter/In den Copy-Paste-Text mit dem angezeigten Zurücksetzungs-Link <b>(Link ist maximal 2 Tage gültig)</b>.<br />
      </p>
    </div>
    <div class="my-4">
      <div class="font-bold">Team erstellen</div>
      <p class="mt-2 leading-normal md:pl-4">
        <b class="mr-3">1.</b>Gehe im Menü auf "Abteilungen" und klicke dann bei deiner Abteilung auf "Bearbeiten". <br />
        <b class="mr-3">2.</b>Klicke danach rechts auf den Button "Team erstellen".<br />
        <b class="mr-3">3.</b>Fülle das Feld "Name" aus und klicke auf "Team erstellen"<br />
      </p>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import HeroIcon from '@/Shared/HeroIcon.vue'
import moment from 'moment/moment'
import LoadingButton from '@/Shared/LoadingButton.vue'
import Search from '@/Shared/Search.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
export default {
  components: {
    Head,
    HeroIcon,
  },
  layout: Layout,
  props: {
    is_admin: Boolean,
    user: Object,
  },
  data() {
    return {

    }
  },
  computed : {

  },
  watch: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>
<style scoped>

</style>

